import React from 'react';
import { CreateForm } from 'framework/form';
import useVacancyService from 'domain/recruiting/vacancy/shared/vacancyService';
import CreateHiringForm from 'domain/recruiting/hiring/createupdate/CreateHiringForm';
import { useVacancyGroupUrl } from 'domain/recruiting/newVacancy/routing';
import { OneStopPageLayout } from 'domain/shared/oneStop';

const OneStopHiringForm = () => {
  const { newDashboard } = useVacancyGroupUrl();
  const { createOneStop, getValidationSchemaOneStop, getInitialData } = useVacancyService();

  return (
    <CreateForm
      submitFormFunc={createOneStop}
      afterSubmit={{
        redirect: newDashboard,
        message: 'You are awesome! The Hiring request has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchemaOneStop}
      getDataFunc={() => getInitialData(true)}
    >
      <OneStopPageLayout>
        <CreateHiringForm />
      </OneStopPageLayout>
    </CreateForm>
  );
};

export default OneStopHiringForm;
